import VueClipboard from 'vue-clipboard2'

export default ({ Vue }) => {
  Vue.use(VueClipboard)
}
